import HeroComponent from './hero.component'

export default HeroComponent
